import { z } from 'zod';
const iataCode = z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z]{3}$/, 'Code IATA à 3 lettres attendu');
export const createFeaturedFlightRouteSchema = z
    .object({
    carrierCodes: z
        .array(z
        .string()
        .trim()
        .toUpperCase()
        .regex(/^[A-Z0-9]{2}$/, 'Code compagnie à 2 caractères attendu'))
        .max(99),
    destinationCode: iataCode,
    destinationLabel: z.string().min(1),
    maxConnections: z.union([z.literal(0), z.literal(1)]),
    originCode: iataCode,
    originLabel: z.string().min(1),
})
    // Une couleur par compagnie dans le calendrier : un direct « toutes compagnies »
    // ou à plusieurs compagnies ne dirait pas laquelle vole quel jour.
    .refine((route) => route.maxConnections === 1 || route.carrierCodes.length === 1, {
    message: 'Un vol direct se déclare avec une seule compagnie',
    path: ['carrierCodes'],
});
/** Route publique du calendrier : deux codes IATA, un paramètre répété est refusé. */
export const getFeaturedFlightDatesQuerySchema = z.object({
    from: iataCode,
    to: iataCode,
});
